<script>
import { ExportedFiles } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'
import FiltersMixin from '@/views/ExportedFiles/FiltersMixin'
import { downloadBlobResponse } from '@/common/js/functions'
import moment from 'moment'
export default {
  mixins: [ListMixin, FiltersMixin],
  data() {
    return {
      verboseName: 'Exportowane pliki',
      verboseNamePlural: 'Exportowane pliki',
      listFields: [
        { prop: 'id', label: 'id' },
        {
          prop: 'status',
          label: 'status zadania',
          formatter: this.getStatusLabel
        },
        {
          prop: 'created',
          label: 'Data utworzenia',
          formatter: this.formatDate('created')
        }
      ]
    }
  },
  computed: {
    service() {
      return ExportedFiles
    }
  },
  methods: {
    refreshList() {
      this.items = []
      this.fetchData()
    },
    headerActions() {
      return [
        this.getButtonComponent({
          label: 'ODŚWIEŻ',
          onClick: this.refreshList,
          disabled: this.listLoading
        })
      ]
    },
    downloadProgressCallback(value) {
      this.downloadProgress = value
    },
    actions(scope) {
      return [
        this.getButtonComponent({
          icon: 'fa fa-download',
          title: 'Pobierz',
          condition: !!scope.row.file && this.downloadProgress === null,
          onClick: () => {
            this.service
              .download(scope.row.file, this.downloadProgressCallback)
              .then(response => {
                const fileName =
                  'mural_zgloszenia_' +
                  moment(scope.row.created).format('YYYY_MM_DD_HH_mm') +
                  '.zip'
                downloadBlobResponse(response, fileName)
                this.downloadProgress = null
              })
              .catch(error => {
                this.$message({
                  message: 'Wystąpił błąd podczas pobierania...',
                  type: 'error'
                })
                this.downloadProgress = null
              })
          }
        })
      ]
    }
  }
}
</script>
